/**
 * Helper function to initialize accordion sections
 * @param {*} sections Node List of accordion sections
 */
export function initializeSections(sections) {
  sections?.forEach((section) => {
    const toggle = section.querySelector(".section__header");
    const body = section.querySelector(".section__body");
    toggle.addEventListener("click", () =>
      toggleSection(section, toggle, body)
    );
  });
}

/**
 * Helper function as switch between states of accordion section
 * @param {*} section Accordion section
 * @param {*} toggle Section toggle (header of the section)
 * @param {*} toggle Section body
 */
function toggleSection(section = null, toggle = null, body = null) {
  if (!section || !toggle || !body) return; // Fallback

  // Get chart level for org-chart control
  const level = parseInt(section?.dataset?.chartLevel);

  // Select parent accordion section if level is deeper than 0
  let parent_section = null;
  if (level >= 1) {
    parent_section = section.parentNode.parentNode.parentNode;
  }

  if (toggle.getAttribute("aria-expanded") === "false") {
    // Show section
    showSection(section, toggle, body, parent_section);
  } else {
    // Hide section
    hideSection(section, toggle, body, parent_section);
  }
}

/**
 * Helper function to show accordion section
 * @param {*} section Accordion section
 * @param {*} toggle Section toggle (header of the section)
 * @param {*} toggle Section body
 * @param {*} parent_section Parent section whose height needs also to be adjusted
 */
export function showSection(
  section = null,
  toggle = null,
  body = null,
  parent_section = null
) {
  if (!section || !toggle || !body) return; // Fallback

  // Set section
  section.classList.add("accordion__section--toggled");

  // Set toggle
  // toggle.setAttribute("aria-pressed", "true");
  toggle.setAttribute("aria-expanded", "true");
  toggle.setAttribute("aria-selected", "true");
  toggle.setAttribute("aria-label", "Sektion schließen");
  toggle.setAttribute("title", "Sektion schließen");
  toggle.querySelector(".icon-frame").setAttribute("aria-label", "Sektion schließen");

  // Set body
  body.setAttribute("aria-hidden", "false");
  body.style.maxHeight = `${body.scrollHeight}px`;

  // Set height of parent section
  if (parent_section) {
    const parent_body = parent_section.querySelector(".section__body");
    const parent_max_height = parent_section.scrollHeight + body.scrollHeight;
    parent_body.style.maxHeight = `${parent_max_height}px`;
  }
}

/**
 * Helper function to hide accordion section
 * @param {*} section Accordion section
 * @param {*} toggle Section toggle (header of the section)
 * @param {*} toggle Section body
 * @param {*} parent_section Parent section whose height needs also to be adjusted
 */
export function hideSection(
  section = null,
  toggle = null,
  body = null,
  parent_section = null
) {
  if (!parent || !toggle || !body) return; // Fallback

  // Set section
  section.classList.remove("accordion__section--toggled");

  // Set toggle
  // toggle.setAttribute("aria-pressed", "false");
  toggle.setAttribute("aria-expanded", "false");
  toggle.setAttribute("aria-selected", "false");
  toggle.setAttribute("aria-label", "Sektion öffnen");
  toggle.setAttribute("title", "Sektion öffnen");
  toggle.querySelector(".icon-frame").setAttribute("aria-label", "Sektion öffnen");

  // Set body
  body.setAttribute("aria-hidden", "true");
  body.style.maxHeight = `0px`;

  // Set height of parent section (remove height from child section from max-height of parent)
  // if (parent_section) {
  //   const parent_body = parent_section.querySelector(".section__body");
  //   const parent_max_height = parent_section.scrollHeight - body.scrollHeight;
  //   parent_body.style.maxHeight = `${parent_max_height}px`;
  // }
}
